module.exports = __webpack_public_path__ + "img/GP2_Slovenia - Advance Circular.363e5498.jpg";